export enum ERROR_CONTENT_TYPE {
  PLAIN = 'PLAIN',
  HTML = 'HTML',
  JSON = 'JSON',
}

export const ErrorTypeRegistry: Record<ERROR_CONTENT_TYPE, string> = {
  PLAIN: 'text/plain',
  HTML: 'text/html',
  JSON: 'application/json',
};
